<ion-card>
  <ion-card-header>
    <ion-card-title>Isolation</ion-card-title>
    <div *ngIf="!siteComplete.privacyCompleted(privacy)" class="required-pill ion-float-end">
      <p class="paragraph">required</p>
    </div>
    <curbnturf-checked *ngIf="siteComplete.privacyCompleted(privacy)"></curbnturf-checked>
  </ion-card-header>
  <ion-card-content class="ion-25-padding">
    <curbnturf-privacy-form #privacyFormComponent [privacyForm]="privacyForm"></curbnturf-privacy-form>
  </ion-card-content>
</ion-card>

<ion-card>
  <ion-card-header>
    <ion-card-title>Noise Level</ion-card-title>
    <div *ngIf="!siteComplete.noiseCompleted(noise)" class="required-pill ion-float-end">
      <p class="paragraph">required</p>
    </div>
    <curbnturf-checked *ngIf="siteComplete.noiseCompleted(noise)"></curbnturf-checked>
  </ion-card-header>
  <ion-card-content class="ion-no-padding">
    <div class="form-wrapper">
      <curbnturf-listing-noise #listingNoiseComponent [noiseForm]="noiseForm"></curbnturf-listing-noise>
    </div>
  </ion-card-content>
</ion-card>

<ion-card *ngIf="!boondock?.id">
  <ion-card-header>
    <ion-card-title>RV & Tent Access</ion-card-title>
    <div
      *ngIf="!siteComplete.vehiclesCompleted(vehicles, rvAccessForm.value.tentOnly)"
      class="required-pill ion-float-end"
    >
      <p class="paragraph">required</p>
    </div>
    <curbnturf-checked *ngIf="siteComplete.vehiclesCompleted(vehicles, rvAccessForm.value.tentOnly)">
    </curbnturf-checked>
  </ion-card-header>
  <ion-card-content class="ion-no-padding">
    <div class="form-wrapper">
      <div class="title-information-wrapper">
        <h4>What kind of RVs are allowed on site?</h4>
      </div>
      <curbnturf-listing-rvs [vehiclesForm]="rvAccessForm.controls.vehicles"></curbnturf-listing-rvs>
      <div class="toggle-wrapper">
        <h4>Is the site you&rsquo;re listing exclusively for tents only?</h4>
        <curbnturf-toggle [selected]="tentOnly?.value" (clicked)="toggleTentOnly()"></curbnturf-toggle>
      </div>
    </div>
  </ion-card-content>
</ion-card>

<ion-card>
  <ion-card-header>
    <ion-card-title>Accommodations</ion-card-title>
    <div *ngIf="!!site?.id && !siteComplete.accommodationsCompleted(amenities)" class="required-pill ion-float-end">
      <p class="paragraph">required</p>
    </div>
    <curbnturf-checked *ngIf="!!site?.id && siteComplete.accommodationsCompleted(amenities)"></curbnturf-checked>
  </ion-card-header>
  <ion-card-content class="ion-no-padding">
    <div class="form-wrapper">
      <curbnturf-boondock-accommodations
        *ngIf="!!boondock?.id"
        [form]="boondockAccommodationsForm"
        [hideLandOwner]="true"
      >
      </curbnturf-boondock-accommodations>
      <curbnturf-listing-accommodations
        #accommodationComponent
        *ngIf="!!site?.id"
        [siteForm]="accommodationsForm"
        [editView]="true"
      >
      </curbnturf-listing-accommodations>
    </div>
  </ion-card-content>
</ion-card>

<ion-card>
  <ion-card-header>
    <ion-card-title>Amenities</ion-card-title>
    <curbnturf-checked></curbnturf-checked>
  </ion-card-header>
  <ion-card-content class="ion-no-padding">
    <div class="form-wrapper">
      <div class="title-information-wrapper">
        <h4>What kind of amenities are available?</h4>
      </div>
      <curbnturf-listing-amenities
        #amenitiesComponent
        [amenities]="amenitiesForm.controls.amenities"
        [signals]="signalReception"
        [extras]="extras"
        [showCustom]="true"
        [boondock]="!!boondock?.id"
      >
      </curbnturf-listing-amenities>
    </div>
  </ion-card-content>
</ion-card>

<ion-card>
  <ion-card-header>
    <ion-card-title>Exclusive Site Activities</ion-card-title>
    <div class="optional-rift-soft">Recommended</div>
  </ion-card-header>
  <ion-card-content class="ion-no-padding">
    <div class="form-wrapper">
      <div class="title-information-wrapper">
        <h4>What activities are accessible exclusively on the site?</h4>
      </div>
      <div>(Select all that apply)</div>
      <curbnturf-onsite-activities [activities]="activities" [showCustom]="true"></curbnturf-onsite-activities>
    </div>
  </ion-card-content>
</ion-card>
